module.exports = __webpack_public_path__ + "static/img/standard.b0eeebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f2/standard.png
// module id = 4/Kl
// module chunks = 0